const faqs = [
  { q: '萝卜影视需要注册吗？', a: '无需注册即可畅享全部功能。萝卜影视致力于提供免费高清电影在线观看服务，打开网站就能直接浏览电影大全、查看热门电影排行榜并开始观影，没有任何门槛。' },
  { q: '电影画质怎么样？缓冲快吗？', a: '我们提供超清画质播放，主流影片支持1080P乃至4K分辨率。采用先进CDN加速技术，确保流畅不缓冲，无论何时何地都能享受高品质观影体验。' },
  { q: '片库更新频率如何？', a: '萝卜影视每日同步最新电影上线，院线热映大片下映后第一时间入库。同时每周更新精选专题，确保影迷始终能看到新鲜内容，从不掉队。' },
  { q: '支持哪些设备观看？', a: '萝卜影视全面适配电脑、平板和手机浏览器，无需安装任何插件。在手机浏览器打开即可享受沉浸式电影在线观看体验，随时随地高清看片。' },
  { q: '影片资源是否正版？', a: '我们高度重视版权保护，所有影片资源均来自合法授权渠道与合作方提供。萝卜影视提倡支持正版，为影迷提供安全、合法的电影在线观看环境。' },
];

export default function FAQSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100 scroll-mt-16">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-50 text-center mb-3">常见问题</h2>
        <p className="text-sm text-foreground-500 text-center mb-10 md:mb-14">关于萝卜影视，你想知道的都在这里</p>
        <div className="space-y-4">
          {faqs.map((item, i) => (
            <details key={i} className="bg-background-50 rounded-xl border border-background-200/60 group" open={i === 0}>
              <summary className="flex items-center justify-between px-5 py-4 cursor-pointer list-none">
                <h3 className="text-base font-semibold text-foreground-200 pr-4">{item.q}</h3>
                <span className="w-6 h-6 flex items-center justify-center flex-shrink-0 text-foreground-500 group-open:hidden">
                  <i className="ri-add-line"></i>
                </span>
                <span className="w-6 h-6 items-center justify-center flex-shrink-0 text-foreground-500 hidden group-open:flex">
                  <i className="ri-subtract-line"></i>
                </span>
              </summary>
              <div className="px-5 pb-4">
                <p className="text-sm text-foreground-500 leading-relaxed">{item.a}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}